export default __webpack_public_path__ + "static/media/new_pig.22668d80.glb";